<app-dialog-top>{{data.title}}</app-dialog-top>
<div mat-dialog-content class="h-100 px-3 py-2">
    <p>{{data.message}}</p>
</div>
<app-dialog-bottom (onSaveClick)="onSubmit($event)" [saveText]="'COMMON.ACTION_CONFIRM' | translate" saveIcon="check"></app-dialog-bottom>
